import apiClient from '@/client/api';
import { UserLevelType } from './me.repository';

export type AuthPayload = {
  credential: string;
  credentialType: 'sms' | 'email';
  inviteCode?: string;
};

export type VerifyOTPPayload = {
  id: string;
  code: string;
};

type AuthVerificationResponse = {
  id: string;
  type: 'sms' | 'email';
};

export type AuthTokenResponse = {
  token: string;
  userId: string;
  userLevel: UserLevelType;
};

export const isAuthTokenResponse = (
  response: AuthVerificationResponse | AuthTokenResponse
): response is AuthTokenResponse => (response as AuthTokenResponse).token !== undefined;

async function signIn(payload: AuthPayload): Promise<AuthVerificationResponse> {
  const response = await apiClient.post('/auth/sign-in', payload);
  return response.data;
}

async function verifyOTP(payload: VerifyOTPPayload): Promise<AuthTokenResponse> {
  const response = await apiClient.post('/auth/verify', payload);
  return response.data;
}

export default {
  signIn,
  verifyOTP,
};
